import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { SubrentalReportFilterModel } from 'src/app/models/subrental/subrental-report-filter.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { GroupService } from 'src/app/services/archive/group.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { SubgroupService } from 'src/app/services/archive/subgroup.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { SubrentalReportService } from 'src/app/services/subrental/subrental-report.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-item-utility',
  templateUrl: './item-utility.component.html',
  styleUrls: ['./item-utility.component.scss'],
  standalone: false
})
export class ItemUtilityComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  filterObserver?: ResizeObserver;
  filtersHeight: number = 0;
  filteredSubgroups: any[] = [];
  formSubrentalReportFilter: FormGroup = new FormGroup({});
  listArticle: any[] = [];
  listBranch: any[] = [];
  listGroup: any[] = [];
  listStore: any[] = [];
  listSubgroup: any[] = [];
  nameWindow: string = 'Informe Utilidad por Equipo';
  projectName = ProjectName.projectName;

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private formBuilder: FormBuilder,
    private groupService: GroupService,
    private headerService: HeaderService,
    private rentalPeriodService: RentalPeriodService,
    private storeService: StoreService,
    private subgroupService: SubgroupService,
    private subrentalReportService: SubrentalReportService,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.getFirstBranchByUserAuthenticatedAsync();
    await this.getAllLists();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();
  }

  changeArticle(articleId: number | null) {
    if (articleId === 0 || articleId === null || articleId === undefined) {
      this.formSubrentalReportFilter.controls["articleId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeFilter() {
    this.changeFilters = false;
  }

  changeGroup(groupId: number | null) {
    this.filterSubgroupByGroupId(groupId);
    if (groupId != 0 && groupId != null) {
      this.formSubrentalReportFilter.controls["subgroupId"].patchValue(0);
    } else {
      this.formSubrentalReportFilter.controls["subgroupId"].patchValue(0);
      this.formSubrentalReportFilter.controls["groupId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeStore(storeId: number | null) {
    if (storeId === 0 || storeId === null || storeId === undefined) {
      this.formSubrentalReportFilter.controls["storeId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeSubgroup(subgroupId: number | null) {
    if (subgroupId != 0 && subgroupId != null) {
      const groupId = this.listSubgroup.find(x => x.value === subgroupId)!.groupId;
      this.formSubrentalReportFilter.controls["groupId"].patchValue(groupId);
      this.filterSubgroupByGroupId(groupId);
    } else {
      this.formSubrentalReportFilter.controls["subgroupId"].patchValue(0);
    }
    this.changeFilter();
  }

  clear() {
    this.changeFilter();
    this.validateForm();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  async exportExcel() {
    if (this.changeFilters) {
      const dateInitial = this.formSubrentalReportFilter.controls['dateInitial'].value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);

      const modelSubrentalReportFilter = this.formSubrentalReportFilter.value as SubrentalReportFilterModel;
      modelSubrentalReportFilter.year = parseInt(year);
      modelSubrentalReportFilter.period = parseInt(period);
      try {
        const response = await firstValueFrom(this.subrentalReportService.exportSubrentalReportItemUtility(modelSubrentalReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Informe Utilidad por Equipo.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  filterSubgroupByGroupId(groupId: number | null) {
    const rowsFiltered = this.listSubgroup.filter(x => x.groupId === groupId);
    if (groupId != null) {
      this.filteredSubgroups = rowsFiltered;
      const subgroupId = this.formSubrentalReportFilter.get("subgroupId")?.value;
      const subgroupExists = this.listSubgroup.some(x => x.groupId === groupId && x.value === subgroupId);

      if (subgroupId && !subgroupExists) {
        this.formSubrentalReportFilter.controls["subgroupId"].patchValue(0);
      }
    } else {
      this.filteredSubgroups = this.listSubgroup;
    }
  }

  async getAllLists() {
    try {
      const [articles, branches, groups, subgroups, stores] = await Promise.all([
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.groupService.getAllGroupsForSelectAsync()),
        firstValueFrom(this.subgroupService.getAllSubgroupsForSelectAsync()),
        firstValueFrom(this.storeService.getAllSubrentalStoresForSelectAsync())
      ]);
      this.listArticle = articles;
      this.listBranch = branches;
      this.listGroup = groups;
      this.listSubgroup = subgroups;
      this.filteredSubgroups = this.listSubgroup;
      this.listStore = stores;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.formSubrentalReportFilter.controls["branchId"].patchValue(branch.branchId);
      this.getLastRentalPeriod(branch.branchId);
      this.filteredSubgroups = this.listSubgroup;
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  async getLastRentalPeriod(branchId: number) {
    try {
      const rentalPeriod = await firstValueFrom(this.rentalPeriodService.getLastRentalPeriod(branchId));
      this.formSubrentalReportFilter.controls["dateInitial"].patchValue(moment(rentalPeriod.initialDate).startOf('month').toDate());
    } catch (error) {
      console.error("Error al consultar el periodo de alquiler:", error);
    }
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast('info', 'No se encontraron datos para imprimir.');
    }
  }

  async send() {
    Object.keys(this.formSubrentalReportFilter.controls).forEach(key => {
      const control = this.formSubrentalReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formSubrentalReportFilter.valid) {
      const dateInitial = this.formSubrentalReportFilter.controls['dateInitial'].value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);

      const modelSubrentalReportFilter = this.formSubrentalReportFilter.value as SubrentalReportFilterModel;
      modelSubrentalReportFilter.year = parseInt(year);
      modelSubrentalReportFilter.period = parseInt(period);

      try {
        this.dataReport = await firstValueFrom(this.subrentalReportService.subrentalReportItemUtility(modelSubrentalReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      dateInitial: {
        required: 'El campo Período es obligatorio.'
      },
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      storeId: {
        notNumber: 'Debe seleccionar una Bodega válida.'
      },
      groupId: {
        notNumber: 'Debe seleccionar un Grupo válido.'
      },
      subgroupId: {
        notNumber: 'Debe seleccionar un Subgrupo válido.'
      },
      articleId: {
        notNumber: 'Debe seleccionar un Artículo válido.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formSubrentalReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formSubrentalReportFilter = this.formBuilder.group({
      dateInitial: ['', [Validators.required]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      storeId: [0, [CustomValidators.numberOnlyValidator()]],
      groupId: [0, [CustomValidators.numberOnlyValidator()]],
      subgroupId: [0, [CustomValidators.numberOnlyValidator()]],
      articleId: [0, [CustomValidators.numberOnlyValidator()]]
    });
  }

}
